module.exports = __webpack_public_path__ + "static/media/suenLogo.abd14787.png";